import { QualifyingAdverb } from '../../types'

const хуёво: QualifyingAdverb = {
  type: 'qualifying adverb',
  adverb: 'хуёво',
  comparative: 'хуёвее',
  superlative: 'хуёвейше',
}

export default хуёво
